const stateRegistry = new Map<string, Record<string, unknown>>();

export interface FrameCtx {
  state: Record<string, unknown>;
  setState(patch: Record<string, unknown>): void;
  theme: Readonly<Record<string, unknown>>;
  emit(name: string, detail?: unknown): void;
  invalidate(): void;
}

/** Drop a frame's ephemeral runtime state (on frame delete or hard reset). */
export function clearFrameState(frameId: string): void {
  stateRegistry.delete(frameId);
}

export function createCtx(opts: {
  frameId: string;
  root: HTMLElement;
  theme?: Record<string, unknown>;
  invalidate?: () => void;
  onState?: (state: Record<string, unknown>) => void;
}): FrameCtx {
  const { frameId, root, theme = {}, invalidate, onState } = opts;
  if (!stateRegistry.has(frameId)) stateRegistry.set(frameId, {});
  return {
    get state() { return stateRegistry.get(frameId)!; },
    setState(patch) {
      const next = { ...stateRegistry.get(frameId)!, ...patch };
      stateRegistry.set(frameId, next);
      onState?.(next);
    },
    theme,
    emit(name, detail) { root.dispatchEvent(new CustomEvent(name, { detail, bubbles: true })); },
    invalidate() { invalidate?.(); },
  };
}
